import React from 'react';
import { areEqual } from 'react-window';
import { ImageType, type LibItemAlbum, type LibItemArticle } from '@types';
import type { ItemListRowProps } from '@components/ItemList';
import Image from '@components/Image';
import TextLink from '@components/TextLink';
import ItemCheckBox from '../components/ItemCheckBox';
import onItemClick from '../actions/onItemClick';
import LibItemName from '../layouts/LibItemName';
import ImgArticle from './img-article.png';
import domain from '../domain';
import AlbumItem from '../components/AlbumItem';
import LibItemDate from '../layouts/LibItemDate';
import LibItemOperator from '../layouts/LibItemOperator';
import LibItemRightPart from '../layouts/LibItemRightPart';

interface Props extends ItemListRowProps {
  data: {
    albums: LibItemAlbum[];
    items: LibItemArticle[];
  };
}

export const onArticleEditClick = domain.event<LibItemArticle>();

function RowArticle({ index, data, style }: Props) {
  const { albums, items } = data;
  const isAlbum = index < albums.length;
  if (isAlbum) {
    const item = albums[index];
    return <AlbumItem style={style} data={item} />;
  }
  const item = items[index - albums.length];
  const { id, thumb, title } = item;

  return (
    <div
      style={style}
      className="group flex h-full cursor-pointer items-center border-b px-20 hover:bg-white-light"
      onClick={() => onItemClick(id)}
    >
      <ItemCheckBox id={id} />
      <Image
        src={thumb || ImgArticle}
        size={32}
        type={thumb ? ImageType.thumb : undefined}
        className="ml-20 h-32 w-32 cursor-pointer bg-white-border"
      />
      <LibItemName>{title}</LibItemName>
      <TextLink
        className="mr-10 hidden flex-shrink-0 group-hover:block"
        onClick={(e) => {
          e.stopPropagation();
          onArticleEditClick(item);
        }}
      >
        编辑
      </TextLink>
      <LibItemRightPart>
        <LibItemOperator name={item.operatorName} />
        <LibItemDate date={item.updateDate} createDate={item.createDate} />
      </LibItemRightPart>
    </div>
  );
}

export default React.memo(RowArticle, areEqual);
